import React from 'react';
import styled from 'styled-components';
import Product from 'components/Product';

// import { getLinkPromise } from 'api/coupang';

// const getLink = async (id) => {
//   const promise = await getLinkPromise(id);
//   const link = promise.data.data[0].shortenUrl;
//   console.log(link);
//   return link;
// };
const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #ed9b88;
  box-shadow: 4px 4px 0 #ed9b88;
  & + & {
    margin-top: 20px;
  }
  .heading {
    text-align: center;
    .rank {
      display: inline-block;
      border-radius: 20px;
      padding: 4px 12px;
      font-weight: 700;
      font-size: 14px;
      color: #fff;
    }
    h4 {
      margin: 16px 0 20px;
      font-size: 24px;
    }
  }
  .desc {
    word-break: break-all;
    letter-spacing: -1px;
    font-size: 14px;
    line-height: 1.6;
    white-space: pre-wrap;
  }
  .product-heading {
    h5 {
      width: 100%;
      text-align: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.54);
      color: rgba(0, 0, 0, 0.54);
      line-height: 0.1em;
      margin: 30px 0;
    }
    span {
      background: #fff;
      padding: 0 8px;
    }
  }
  .product-list {
    display: flex;
    flex-flow: row wrap;
  }
  .shopping-btn {
    text-decoration: none;
    display: block;
    color: white;
    background-color: #3c5975;
    text-align: center;
    padding: 8px;
    font-weight: bold;
    font-size: 13px;
    border-radius: 4px;
    margin-top: 10px;
  }
`;

const Hobby = ({ hobby, products, rank }) => {
  return (
    <Wrapper>
      <div className="heading">
        {rank && <div className="rank orange-bg mont">{rank} 순위 추천</div>}
        <h4 className="gana navy">{hobby.displayName}</h4>
      </div>
      <div className="desc">{hobby.desc}</div>
      <a
        href={hobby.link}
        target="_blank"
        rel="noreferrer"
        className="shopping-btn"
      >
        {hobby.displayName.slice(0, hobby.displayName.length - 3)} 관련 용품
        살펴보기
      </a>
      {/* <div className="product-heading">
        <h5>
          <span>
            혹시 몰라서 찾아온{' '}
            {hobby.displayName.slice(0, hobby.displayName.length - 3)} 관련 용품
          </span>
        </h5>
      </div>
      <div className="product-list">
        {products.map((product, index) => (
          <Product product={product} key={index} />
        ))}
      </div> */}
    </Wrapper>
  );
};

export default Hobby;
